import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-barra-accesibilidad-implement',
  templateUrl: './barra-accesibilidad-implement.component.html',
  styleUrls: ['./barra-accesibilidad-implement.component.scss']
})
export class BarraAccesibilidadImplementComponent implements OnInit {
  utils: any;
  constructor() {
    this.utils = window.utils;
  }
  
  ngOnInit() {
    this.utils.initAccesibilidad();
  }

}
